import React from 'react'
import tw from 'tailwind-styled-components'
import {DataObjectId, newsCompanyId} from 'yougile-model'
import {Sync} from '@client/sync'
import {LinkButton} from '@components/common/base/buttons'
import {createEnhancedWithSyncedFullTaskChat} from '@containers/enhanced-with-full-task-chat/enhanced-with-synced-full-task-chat'
import {News} from '@extensions/news'
import {FullTaskChatProxy} from '@extensions/proxies/full-task-chat-proxy'
import {ChatNav} from './chat-nav'

const TwNewsHeader = tw.div`
  px-24
  pb-12
  flex
  flex-col
  gap-8
`

const TwName = tw.div`
  min-w-0
  text-18
  leading-6
  font-semibold
  break-words
`

const TwButtons = tw.div`
  flex
  gap-4
`

const TwPopupOption = tw.div`
  plain-text-regular
`

const BaseNewsHeader = ({chatName, chatId}: FullTaskChatProxy) => {
  const hub = Sync.newsSandbox?.getHub(chatId)
  const canEdit = News.canEdit()
  const isWithPopup = News.isWithPopup(hub)
  const toggle = () => hub && News.setWithPopup(hub, !isWithPopup)

  return (
    <>
      <ChatNav />
      <TwNewsHeader>
        <TwName>{chatName}</TwName>
        {canEdit && (
          <TwButtons>
            <TwPopupOption>
              Новость {isWithPopup ? 'с попапом' : 'без попапа'}
            </TwPopupOption>
            <LinkButton
              onClick={toggle}
              noPaddings
              className="plain-text-regular"
            >
              Поменять
            </LinkButton>
          </TwButtons>
        )}
      </TwNewsHeader>
    </>
  )
}

export const NewsHeader = (props: {chatId: DataObjectId}) => {
  const Component = createEnhancedWithSyncedFullTaskChat(BaseNewsHeader)
  return <Component chatId={props.chatId} companyId={newsCompanyId} />
}
